import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  onOpenAgeVerificationCompletePopup,
  onOpenAgeVerificationNotCompletedPopup,
} from "@/components/popup-dispatcher/PopupDispatcher";
import {
  AGE_VERIFICATION_FAILED,
  AGE_VERIFICATION_SUCCESS,
  getAgeVerificationSourceFromSearch,
  getAgeVerificationStatusFromSearch,
} from "@/common/utils/ageVerification";
import { useAnalyticsStore } from "@/common/store/analyticsStore";

export const useAgeVerificationStatusPopup = () => {
  const { search } = useLocation();
  const setAvPromptSource = useAnalyticsStore((state) => state.setAvPromptSource);

  useEffect(() => {
    const verificationStatus = getAgeVerificationStatusFromSearch(search);

    if (!verificationStatus) {
      return;
    }

    setAvPromptSource(getAgeVerificationSourceFromSearch(search));

    if (verificationStatus === AGE_VERIFICATION_SUCCESS) {
      onOpenAgeVerificationCompletePopup();
      return;
    }

    if (verificationStatus === AGE_VERIFICATION_FAILED) {
      onOpenAgeVerificationNotCompletedPopup();
    }
  }, [search, setAvPromptSource]);
};
